(function(){
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  var WA=(document.body.dataset.wa||'').replace(/\D/g,'');

  var b=document.getElementById('burger'),m=document.getElementById('menu');
  if(b&&m){b.onclick=function(){var o=m.classList.toggle('open');b.setAttribute('aria-expanded',o)};
    m.addEventListener('click',function(e){if(e.target.tagName==='A'){m.classList.remove('open');b.setAttribute('aria-expanded','false')}})}

  document.querySelectorAll('[data-rail]').forEach(function(btn){
    btn.addEventListener('click',function(){var r=document.getElementById(btn.dataset.rail);if(!r)return;var t=r.querySelector('.tile,.review');r.scrollBy({left:((t?t.offsetWidth:300)+16)*btn.dataset.dir,behavior:reduce?'auto':'smooth'})});
  });
  document.querySelectorAll('.rail').forEach(function(r){
    var down=false,x=0,s=0,moved=false;
    r.addEventListener('pointerdown',function(e){if(e.pointerType!=='mouse')return;down=true;moved=false;x=e.clientX;s=r.scrollLeft;r.style.scrollSnapType='none'});
    window.addEventListener('pointermove',function(e){if(!down)return;var d=e.clientX-x;if(Math.abs(d)>5)moved=true;r.scrollLeft=s-d});
    window.addEventListener('pointerup',function(){if(!down)return;down=false;r.style.scrollSnapType=''});
    r.addEventListener('click',function(e){if(moved){e.preventDefault();e.stopPropagation();moved=false}},true);
  });

  var dlg=document.getElementById('dlg');
  if(dlg){
    document.querySelectorAll('.tile[data-open]').forEach(function(t){
      t.addEventListener('click',function(){var tp=document.getElementById('spec-'+t.dataset.open);if(!tp)return;
        document.getElementById('dlg-tag').textContent=tp.dataset.tag||'';document.getElementById('dlg-t').textContent=tp.dataset.title||'';document.getElementById('dlg-b').innerHTML=tp.innerHTML;
        if(dlg.showModal)dlg.showModal();else dlg.setAttribute('open','')});
    });
    dlg.querySelectorAll('[data-close]').forEach(function(c){c.addEventListener('click',function(){dlg.close()})});
    dlg.addEventListener('click',function(e){if(e.target===dlg)dlg.close()});
  }

  document.querySelectorAll('[data-go]').forEach(function(c){c.addEventListener('click',function(e){
    var t=document.querySelector('.tile[data-key="'+c.dataset.go+'"]');if(!t)return;e.preventDefault();
    var sec=t.closest('section'),r=t.closest('.rail');sec.scrollIntoView({behavior:reduce?'auto':'smooth'});
    setTimeout(function(){var pad=parseInt(getComputedStyle(r).scrollPaddingLeft)||0;r.scrollTo({left:t.offsetLeft-r.offsetLeft-pad,behavior:reduce?'auto':'smooth'});
      t.classList.remove('hl');void t.offsetWidth;t.classList.add('hl');t.focus({preventScroll:true})},reduce?0:600);
  })});

  document.querySelectorAll('.facts').forEach(function(f){
    var panel=document.getElementById(f.querySelector('[role=tab]').getAttribute('aria-controls'));
    f.querySelectorAll('[data-msp]').forEach(function(x){x.addEventListener('click',function(){
      f.querySelectorAll('[data-msp]').forEach(function(y){y.setAttribute('aria-selected',y===x)});
      panel.querySelectorAll('[data-msp-panel]').forEach(function(p){p.hidden=p.dataset.mspPanel!==x.dataset.msp});
      panel.classList.remove('swap');void panel.offsetWidth;panel.classList.add('swap');
    })});
  });

  if(!reduce&&'IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(en){if(!en.isIntersecting)return;io.unobserve(en.target);var el=en.target,end=+el.dataset.count,suf=el.dataset.suffix||'',t0=null;
      function f(ts){if(!t0)t0=ts;var p=Math.min(1,(ts-t0)/1400);el.textContent=Math.round(end*(1-Math.pow(1-p,3)))+suf;if(p<1)requestAnimationFrame(f)}requestAnimationFrame(f)})},{threshold:.6});
    document.querySelectorAll('[data-count]').forEach(function(el){if(+el.dataset.count)io.observe(el)});
  }

  var box=document.querySelector('[data-quiz]');
  if(box){
    var qEl=box.querySelector('#q'),bar=box.querySelector('#qbar'),A=[];
    var Q=[
      {q:'Qual è il tuo obiettivo principale?',o:['Tonificare e rassodare','Dimagrire','Glutei più alti e forti','Gambe gonfie, cellulite o lipedema']},
      {q:'Dove preferisci allenarti?',o:['In studio a Napoli, con te','In palestra da sola','A casa']},
      {q:'Quanto vuoi essere seguita?',o:['Mi basta un programma fatto bene','Voglio una consulenza approfondita','Voglio te accanto a ogni seduta']}
    ];
    function res(n){var p=(box.dataset['r'+n]||'||').split('|');return{n:p[0],pr:p[1],d:p[2],l:box.dataset['r'+n+'l']||'#percorsi'}}
    function esc(s){var d=document.createElement('div');d.textContent=s||'';return d.innerHTML}
    function render(i){
      bar.style.width=((i+1)/(Q.length+1)*100)+'%';
      if(i>=Q.length)return result();
      var h='<p class="qstep">Domanda '+(i+1)+' di '+Q.length+'</p><h3>'+Q[i].q+'</h3><div class="opts">';
      Q[i].o.forEach(function(o,k){h+='<button type="button" class="opt" aria-pressed="false" data-k="'+k+'">'+o+'</button>'});
      qEl.innerHTML=h+'</div>'+(i?'<p style="margin:16px 0 0"><button class="linkbtn" type="button" data-back>Indietro</button></p>':'');
      qEl.querySelectorAll('.opt').forEach(function(bt){bt.onclick=function(){bt.setAttribute('aria-pressed','true');A[i]=+bt.dataset.k;setTimeout(function(){render(i+1)},220)}});
      var bk=qEl.querySelector('[data-back]');if(bk)bk.onclick=function(){render(i-1)};
    }
    function result(){
      var p=(A[1]===0||A[2]===2)?res(1):(A[2]===1)?res(2):(A[0]===3)?res(3):res(4);
      var msg=encodeURIComponent('Ciao Gennaro, ho fatto il quiz sul sito e mi è uscito il percorso '+p.n+'. Vorrei saperne di più.');
      qEl.innerHTML='<div class="result"><span class="tag">Il tuo percorso</span><h3>'+esc(p.n)+'</h3><p>'+esc(p.d)+'</p><p class="pr">'+esc(p.pr)+'</p><div class="row"><a class="btn btn-black" href="'+esc(p.l)+'">Vedi il percorso</a>'+(WA?'<a class="btn" style="background:rgba(0,0,0,.1);color:#000" target="_blank" rel="noopener" href="https://wa.me/'+WA+'?text='+msg+'">Chiedi a Gennaro</a>':'')+'</div></div><p style="margin:14px 0 0"><button class="linkbtn" type="button" data-re>Rifai il quiz</button></p>';
      qEl.querySelector('[data-re]').onclick=function(){A=[];render(0)};
    }
    render(0);
  }

  var mc=document.getElementById('mcta'),hero=document.querySelector('.hero');
  if(mc){if(hero&&'IntersectionObserver' in window)new IntersectionObserver(function(es){mc.classList.toggle('show',!es[0].isIntersecting)}).observe(hero);else mc.classList.add('show')}
})();
